import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import ProfessionalHealthPage from './pages/ProfessionalHealthPage';
import HelpPage from './pages/HelpPage';
import DoctorResumePage from './pages/DoctorResumePage';
import AppRedirect from './components/redirector';
import './App.css';
import Inscription from './components/inscription/Inscription';
import SuccessPage from './pages/SuccessPage';

function MainApp() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
  document.documentElement.setAttribute("translate", "no");
  document.documentElement.classList.add("notranslate");
  // ensure lang is correct
  document.documentElement.lang = "fr"; // or "ar"
  const meta = document.createElement("meta");
  meta.name = "google";
  meta.content = "notranslate";
  document.head.appendChild(meta);
}, []);


  return (
    <>
      {!isHomePage && <Header />}
      <main>
        <Routes>
            <Route path="/redirector" element={<AppRedirect />} />
          <Route path="/" element={<Home />} />
          <Route path="/professionnel-sante" element={<ProfessionalHealthPage />} />
          <Route path="/aide" element={<HelpPage />} />
          <Route path="/doctor/:id" element={<DoctorResumePage />} />
            <Route path="/inscription/:code" element={<Inscription />} />
            <Route path="/inscription/:code/:entrepriseId" element={<Inscription />} />
            <Route path="/inscription/success" element={<SuccessPage />} />

        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <MainApp />
    </Router>
  );
}

export default App;
